import React, { useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import { useFormik } from 'formik'
import axios from 'axios'
import Loader from '../../components/loader/loader'
import parse from 'html-react-parser'

const RequestCallback = ({ title }) => {
    const { wp: { general: { settingsGeneral: { requestACallbackForm }}}} = useStaticQuery(graphql`
        query GetCallbackForm {
          wp {
            general {
              settingsGeneral {
                requestACallbackForm {
                  ... on WpContactForm {
                    formId: databaseId
                  }
                }
              }
            }
          }
        }
    `)
    const FORM_ID = requestACallbackForm ? requestACallbackForm.formId : null;
    if(!FORM_ID) {
        return <></>
    }
    const [ errors, setErrors ] = useState([])
    const [ loading, setLoading] = useState(false)
    const [ isSuccessMessage, setIsSuccessMessage] = useState(false)
    const [ messageSent, setMessageSent] = useState(false)

    const {
        handleChange,
        isSubmitting,
        values,
        handleSubmit,
    } = useFormik({
        initialValues: {
          firstname: '',
          lastname: '',
          telephone: '',
          url: typeof window !== 'undefined' ? window.location.href : 'Not defined',
          newsconsent: true,
        },
        onSubmit: ({
          firstname,
          telephone,
          lastname,
          url,
          newsconsent
        }, { setSubmitting, resetForm }) => {
                setErrors([])
                setLoading(true)
                setSubmitting(true)
                setMessageSent(false)
                setIsSuccessMessage(false)

                const bodyFormData = new FormData();
                bodyFormData.set('firstname', firstname);
                bodyFormData.set('lastname', lastname);
                bodyFormData.set('telephone', telephone);
                bodyFormData.set('newsconsent', newsconsent);
                bodyFormData.set('url', url);
                axios.post(`${process.env.API_URL}/wp-json/contact-form-7/v1/contact-forms/${FORM_ID}/feedback`, bodyFormData, {
                    headers: {
                      // 'Authorization': `Bearer ${token}`,
                      'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    if(response.data.status === 'mail_sent'){
                        resetForm()
                        setLoading(false)
                        setSubmitting(false)
                        setMessageSent(true)
                        setIsSuccessMessage(true)
                    }
                    else if(response.data.status === 'validation_failed') {
                        response?.data?.invalid_fields?.map(item => {
                            const prevErr = errors
                            prevErr[item.idref] = item.message
                            setErrors(prevErr)
                        })
                        setLoading(false)
                        setSubmitting(false)
                    }
                    else {
                        setLoading(false)
                        setSubmitting(false)
                        setMessageSent(true)
                        setIsSuccessMessage(false)
                    }
                }).catch(error => {
                    setLoading(false)
                    setSubmitting(false)
                    setMessageSent(true)
                    setIsSuccessMessage(false)
                })
        },
    })

    return (
        <form className="relative container max-w-5xl" onSubmit={handleSubmit}>
            {
              typeof window !== 'undefined' && window.location.href &&
                <input type="hidden" name="url" value={values.url} />
            }
            {
                loading &&
                <Loader light={false} />
            }

            <h3 className="font-serif font-light text-4xl lg:text-5xl sm:max-w-xs text-tan-100">
              {
                parse(title || 'Enquire about this home')
              }
            </h3>
            <div className="my-6 text-tan-900">Please fill in the form below and we will get back to you.</div>
            <div className="mb-4">
              <label className="block text-tan-900 text-sm font-bold mb-2" htmlFor="firstname">First name <sup className="text-tan-500">*</sup></label>
              <input
                className="w-full block focus:ring-tan-700 focus:border-white border-white"
                id="firstname"
                name="firstname"
                type="text"
                placeholder="First name"
                onChange={handleChange}
                value={values.firstname}
              />
              { errors.firstname &&
                <div className="text-tan-100 font-serif text-sm mt-1">{ errors.firstname }</div>
              }
            </div>
            <div className="mb-4">
              <label className="block text-tan-900 text-sm font-bold mb-2" htmlFor="lastname">Last name <sup className="text-tan-500">*</sup></label>
              <input
                className="w-full block focus:ring-tan-700 focus:border-white border-white"
                id="lastname"
                name="lastname"
                type="text"
                placeholder="Last name"
                onChange={handleChange}
                value={values.lastname}
              />
              { errors.lastname &&
                <div className="text-tan-100 font-serif text-sm mt-1">{ errors.lastname }</div>
              }

            </div>
            <div className="mb-4">
              <label className="block text-tan-900 text-sm font-bold mb-2" htmlFor="telephone">Telephone number <sup className="text-tan-500">*</sup></label>
              <input
                className="w-full block focus:ring-tan-700 focus:border-white border-white"
                id="telephone"
                name="telephone"
                type="text"
                placeholder="07123 456789"
                onChange={handleChange}
                value={values.telephone}
              />
              { errors.telephone &&
                <div className="text-tan-100 font-serif text-sm mt-1">{ errors.telephone }</div>
              }

            </div>

            <div className="mb-4">
              <label className="inline-flex items-center">
                <input onChange={ handleChange } checked={ values.newsconsent } id="newsconsent" name="newsconsent" type="checkbox" className="border-white text-tan-800 focus:ring-tan-800" />
                <span className="ml-2 text-white">Tick this box if you are ok with being contacted by us with news about our products and services.</span>
              </label>
            </div>
            <div>

                <button
                  className="bg-tan-800 cursor-pointer text-white px-6 font-bold py-3 rounded-full w-full"
                  type="submit"
                  disabled={ isSubmitting }
                >
                    Send enquiry
                </button>
            </div>

            { isSuccessMessage && messageSent && (
                <div className="bg-tan-100 mt-5 rounded-full text-tan-700 text-center px-6 py-2">Message sent successfully!</div>
            )}

            { !isSuccessMessage && messageSent && (
                <div className="bg-black mt-5 rounded text-white text-center px-6 py-2">There is been an error sending your message. Please try again.</div>
            )}

        </form>
    )
}
export default RequestCallback
